var _VegaStreamProfileLoader_instances, _VegaStreamProfileLoader_privateKey, _VegaStreamProfileLoader_getUrl;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import axios from 'axios';
export class VegaStreamProfileLoader {
    constructor(privateKey) {
        _VegaStreamProfileLoader_instances.add(this);
        _VegaStreamProfileLoader_privateKey.set(this, void 0);
        __classPrivateFieldSet(this, _VegaStreamProfileLoader_privateKey, privateKey, "f");
    }
    async load() {
        const url = __classPrivateFieldGet(this, _VegaStreamProfileLoader_instances, "m", _VegaStreamProfileLoader_getUrl).call(this);
        const { data } = await axios.get(url);
        return {
            afreecaId: data.afreecaId,
            backgroundImage: data.backgroundImage,
            localId: data.localHash,
            platform: data.platform,
            twitchId: data.twitchId,
        };
    }
}
_VegaStreamProfileLoader_privateKey = new WeakMap(), _VegaStreamProfileLoader_instances = new WeakSet(), _VegaStreamProfileLoader_getUrl = function _VegaStreamProfileLoader_getUrl() {
    return `https://mycast.xyz:9011/user/${__classPrivateFieldGet(this, _VegaStreamProfileLoader_privateKey, "f")}/stream`;
};
